import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      width: '100%',
      padding: theme.spacing(0.5),
    },
    calendarContainer: {
      backgroundColor: 'white',
      padding: theme.spacing(0.5),
    },
    weekGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(7, 1fr)',
      gap: theme.spacing(0.5),
    },
    dayHeader: {
      padding: theme.spacing(0.5),
      backgroundColor: '#f8f9fa',
      textAlign: 'center',
      fontWeight: 600,
      borderRadius: theme.shape.borderRadius,
    },
    todayHeader: {
      backgroundColor: '#333',
      color: 'white',
    },
    labelsContainer: {
      display: 'flex',
      flexDirection: 'column',
      gap: '2px',
      alignItems: 'center',
    },
    holidayLabel: {
      fontSize: '0.5rem',
      color: 'black',
      backgroundColor: '#f57c00',
      fontWeight: 600,
      padding: '1px 4px',
      borderRadius: '3px',
      display: 'inline-block',
    },
    specialEventLabel: {
      fontSize: '0.5rem',
      color: 'white',
      backgroundColor: '#f44336',
      fontWeight: 600,
      padding: '1px 4px',
      borderRadius: '3px',
      display: 'inline-block',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    servicesSectionContainer: {
      marginTop: '8px',
    },
    timeFormatContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: '16px',
      justifyContent: 'flex-start',
    },
    timeFormatLabel: {
      marginRight: 10,
      fontSize: 15,
    },
    timeFormatSelect: {
      minWidth: 140,
    },
    timeFormatSelectInput: {
      fontSize: 15,
    },
  }),
);
